import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Navigate, Outlet } from 'react-router-dom';

import { config } from '../../../../config/config';
import { localeStore, selectFullLocale } from '../../../shared/store/locale.store';
import { parseLocale, isValidLocale } from '../../../shared/utils/language';

export const LocaleRedirect = () => {
    const { locale } = useParams();
    const currentLocale = useSelector(selectFullLocale);
    const dispatch = useDispatch();
    const activeMaintenance = false;

    // const startDate = useIntl().formatMessage({ id: 'start.date.maintenance' });
    // console.log(startDate);

    const [isTimeReached, setIsTimeReached] = useState(false);

    const parsedLocale = useMemo(() => {
        if (!isValidLocale(locale)) {
            return;
        }

        const parsedLocale = parseLocale(locale);

        return parsedLocale;
    }, [locale]);

    useEffect(() => {
        if (locale !== currentLocale && parsedLocale) {
            dispatch(
                localeStore.actions.changeLocale({
                    region: parsedLocale.region,
                    language: parsedLocale.language ?? config.DEFAULT_LANGUAGE,
                    script: parsedLocale.script,
                    fullLocale: locale ?? config.DEFAULT_LOCALE,
                }),
            );
        }
    }, [locale, parsedLocale, dispatch, currentLocale]);

    // useEffect(() => {
    //     const futureDateTime = new Date('2023-07-11T02:00:00'); // End time of the live demo
    //
    //     const checkTime = () => {
    //         const localDateTime = new Date();
    //         console.log(futureDateTime, 'ending date');
    //         const currentDateTime = new Date(
    //             localDateTime.getTime() + localDateTime.getTimezoneOffset() * 60000,
    //         );
    //         console.log(currentDateTime, 'live date');
    //
    //         if (currentDateTime >= futureDateTime) {
    //             setIsTimeReached(true);
    //         }
    //     };
    //     checkTime();
    //     const interval = setInterval(checkTime, 100000); // Check time every 10 second
    //
    //     return () => {
    //         clearInterval(interval);
    //     };
    // }, [locale, parsedLocale, dispatch, currentLocale]);

    if (isTimeReached && activeMaintenance) {
        return (
            <div>
                The live demo has come to an end! Please be patient until our official release.
            </div>
        );
    }

    if (typeof locale !== 'string' && !!locale) {
        return <Navigate to="/sports" />;
    }

    if (!parsedLocale && locale !== currentLocale) {
        return <Navigate to={['/', currentLocale, window.location.pathname].join('')} />;
    }

    return <Outlet />;
};
